import React from 'react';

import { AbstractMedia } from 'types/AbstractMedia';
import type { MayBe } from 'types/common';

const getPathWithoutSignature = (path: string): string => {
  const { origin, pathname } = new URL(path);
  return `${origin}${pathname}`;
};

export const getMediaIdentity = (media: MayBe<AbstractMedia>): MayBe<string> => {
  if (!media) {
    return undefined;
  }
  return media.id ?? getPathWithoutSignature(media.path);
};

/**
 * Returns a stable media reference that only changes when the underlying asset
 * identity changes (its id, or its path ignoring the signed query string).
 */
const useStableMedia = (media: MayBe<AbstractMedia>): MayBe<AbstractMedia> => {
  const stableMedia = React.useRef<MayBe<AbstractMedia>>(media);

  if (getMediaIdentity(media) !== getMediaIdentity(stableMedia.current)) {
    stableMedia.current = media;
  }

  return stableMedia.current;
};

export default useStableMedia;
